import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import OnboardingTemplate from './OnboardingTemplate';
import images from '../../../utils/Images';
var SplashScreen = function () {
    return (_jsxs(OnboardingTemplate, { children: [_jsx("img", { src: images.logoAnchor, alt: "MyDockInfo Logo", className: "onboarding-logo" }), _jsx("strong", { className: "onboarding-title", children: "MyDockInfo" }), _jsxs("div", { className: "flex flex-row", children: [_jsx("small", { className: "onboarding-subtext", children: "The place to go for" }), _jsx("small", { className: "onboarding-highlight", children: "\u00A0what you need to Know" })] })] }));
};
export default SplashScreen;
